import { Link } from "react-router-dom";
import "../Services.css";
import { useState } from "react";

const FAQSection = () => {
  const faqs = [
    {
      question: "1. Can I do my own bookkeeping, or should I hire a professional?",
      answer: [
        "While small businesses can manage their own bookkeeping, hiring a professional ensures:",
        "✔ Fewer mistakes & better accuracy.",
        "✔ Tax compliance & maximum deductions.",
        "✔ Time savings, allowing you to focus on growing your business."
      ].join('\n')
    },
    {
      question: "2. What software do you use for bookkeeping?",
      answer: "We use industry-leading software including QuickBooks, Xero, and Zoho Books for our bookkeeping services."
    },
    {
      question: "3. Do I need professional bookkeeping services?",
      answer: "If your business is growing or if you have trouble managing your finances, professional bookkeeping services can help. It ensures accuracy, saves time, and frees you up to focus on other aspects of your business."
    },
    {
      question: "4. How do you price your bookkeeping services?",
      answer: "We offer flexible pricing options including monthly packages based on transaction volume, hourly rates for specific projects, and customized solutions for businesses with unique needs."
    }
  ];

  const [openIdx, setOpenIdx] = useState(null);
  const toggle = (idx) => setOpenIdx((prev) => (prev === idx ? null : idx));

  return (
    <div className="faq-section py-5">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="section-title1">Bookkeeping FAQs</h2>
          <Link to="/pricing" className="see-plan-link">
            See Plan &rarr;
          </Link>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="faq-accordion">
              {faqs.map((faq, index) => {
                const isOpen = openIdx === index;
                return (
                  <div className="faq-item" key={index}>
                    <button
                      type="button"
                      className="faq-toggle"
                      aria-expanded={isOpen}
                      aria-controls={`faq-content-${index}`}
                      onClick={() => toggle(index)}
                    >
                      <h5 className="faq-question m-0">{faq.question}</h5>
                      <span className="faq-icon" aria-hidden>{isOpen ? '−' : '+'}</span>
                    </button>
                    <div
                      id={`faq-content-${index}`}
                      className={`faq-content ${isOpen ? 'open' : ''}`}
                      role="region"
                      aria-labelledby={`faq-toggle-${index}`}
                    >
                      <div className="faq-content-inner">
                        <p className="faq-answer" style={{ whiteSpace: 'pre-line', marginBottom: 0 }}>
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;